import React, { useState } from 'react'
import './Login.css'
import SignInScreen from './SignInScreen'

function Login() {
  const [signIn, setSignIn] = useState(false)
  return (
    <div className='login'>
      <div className='loginScreen__background'>
        <img className='loginScreen__logo' src='https://assets.stickpng.com/images/580b57fcd9996e24bc43c529.png' alt='logo'/>
      <button onClick={() => setSignIn(true)} className='loginScreen__button'>Sign In</button>
      <div className='loginScreen__gradient' />
      </div>
      <div className='loginScreen__body'>
        {signIn ? (<SignInScreen/>) : (
           <>
           <h1>Unlimited films, TV programmes and more.</h1>
           <h2>Watch anywhere. Cancel at any time.</h2>
           <h3>Ready to watch? Enter your email to create or restart any membership</h3>
           <div className='loginScreen__input'>
             <form>
             <input type="email" placeholder='Enter email...'/>
             <button onClick={() => setSignIn(true)} className='loginScreen__getStarted'>GET STARTED</button>
             </form>
           </div>
           </>
        )}
       
      </div>
    </div>
  )
}

export default Login